<style>


  ::ng-deep app-radio-group.formField {
    width: auto;
  }

  ::ng-deep app-radio-group .radiobox-container {
    flex-wrap: nowrap;
  }

  .terminalLayout {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    align-items: start;
  }

  .terminalLayout-main {
    min-width: 0;
  }

  .terminalLayout-sidebar {
    position: sticky;
    top: calc(var(--app-sticky-chrome-height, 0px) + 8px);
  }

  .invoiceItem {
    display: table-cell;
    border-bottom: 1px solid #dddddd;
    padding: 10px 15px 10px 0px;
    font-weight: normal;
  }

  .stackedInput {
    margin-bottom: 1em;
  }
  .stackedInput div:first-child {
    font-size: 1em;
    font-weight: 500;
    color: var(--colorOta);
  }
  .stackedInput div:nth-child(2) {
    margin-top: -1px;
  }

  .transactionsTable {
    display: table;
    width: 100%;
  }
  .transactionTable td {
    padding: 10px 0px;
  }



  /* (M4) - still used?? */
  .tabs {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-bottom: 3px;
    gap: 10px;

    > .tab {
      border: 1px solid #bbbbbb;
    }
  }
</style>

<app-access-manager [namespace]="namespace">

  <div [hidden]="allowTransactions">
    This account is currently not configured to accept payments.
  </div>

  <div [hidden]="!allowTransactions">

    <app-page-header text="Virtual Terminal"></app-page-header>

    <div class="row" [hidden]="merchantId != ''">
      You must select a merchant first.
    </div>

    <div [hidden]="merchantId == ''">

      <div class="width-comfortable" style="margin-bottom: 20px" [hidden]="this.transactionResponse == undefined">
        <div style="margin-bottom: 10px" [hidden]="this.transactionResponse?.success == true">
          <div>
            The transaction could not be processed:
            {{ this.transactionResponse?.error }}
          </div>
        </div>
        <div style="margin-bottom: 20px; padding: 20px; border: 1px solid #eeeeee;" [hidden]="this.transactionResponse?.success == false">
          <app-terminal-receipt [customer]="selectedCustomer" [transactionResponse]="transactionResponse" [transactionType]="selectedTransactionFriendlyName"></app-terminal-receipt>
        </div>
        <div style="text-align: center">
          <input
            type="button"
            value="Start a new transaction"
            class="primary"
            (click)="btnNewTransaction_click()"
          />
        </div>
      </div>

      <div class="terminalLayout" [hidden]="this.transactionResponse != undefined && this.transactionResponse.success == true">

        <!-- main content-->
        <div class="terminalLayout-main">
          <div class="greenContainer" style="margin-bottom:15px;  padding: 20px 14px; font-size:.9em;" [hidden]="showPane(PaneEnum.Refund)">
            <div style="display:flex; flex-direction: row; gap:10px;">
              <span style="font-weight:500;">Select a payment type to begin a transaction.</span>
              <app-radio-group [options]="paymentTypeOptions" [(ngModel)]="selectedMode" (ngModelChange)="handlePaymentTypeChanged()"></app-radio-group>
            </div>
          </div>

          <div [hidden]="selectedMode == undefined">

            <div [hidden]="!showPane(PaneEnum.OrderDetails)" style="margin-bottom: 20px; padding: 20px; border: 1px solid #eeeeee;">
              <div style="width: 100%; font-size:1.2e; font-weight:400; margin-bottom: 15px;" >
                01 Order Details
              </div>

              <app-terminal-order [level2Level3PaneExpanded]="level2Level3PaneExpanded" [orderDetails]="orderDetails" (onChargeAmountChanged)="txtChargeAmount_keyup($event)" (onTransactionTypeChanged)="selectTransType_click($event)" (onRecurringUpdate)="handleRecurringUpdate($event)"></app-terminal-order>
            </div>

            <div [hidden]="!showPane(PaneEnum.Refund)" style="margin-bottom: 20px; padding: 20px; border: 1px solid #eeeeee;">
              <div style="width: 100%; font-size:1.2e; font-weight:400; margin-bottom: 15px;" >
                01 Refund Details
              </div>

              <app-textbox [label]="'Charge Amount'" [readonly]="!allowChargeAmountChange" [(ngModel)]="amountToTransact" width="100%" [minNumericValue]="0" [showDefaultValue]="false" [required]="true" [type]="inputTextModes.CurrencyUSD" [validateOn]="'change'" (onChanged)="changeRefundAmount($event)"></app-textbox>

            </div>

            <div style="margin-bottom: 20px; padding: 20px; border: 1px solid #eeeeee;" [hidden]="!showPane(PaneEnum.Customer)">
              <div style="width: 100%; font-size:1.2e; font-weight:400; margin-bottom: 15px;" >
                02 Customer Details
              </div>

              <app-terminal-customer [merchantId]="merchantId" (onCustomerChange)="handleSelectedCustomerChanged($event)"></app-terminal-customer>
            </div>

            <div [hidden]="!showPane(PaneEnum.Billing)">
              <div style="margin-bottom: 20px; padding: 20px; border: 1px solid #eeeeee;">
                <div style="width: 100%; font-size:1.2e; font-weight:400; margin-bottom: 15px;" >
                  03 Payment
                </div>
                <app-terminal-billing-form
                  [achEnabled]="achEnabled"
                  [merchantId]="merchantId"
                  [customerId]="selectedCustomer?.id"
                  [selectedPaymentType]="selectedMode"
                  (onSelectedPaymentMethod)="handleSelectedPaymentMethodChanged($event)"
                  (onValidationChange)="handleTokenizeFormValidationChanged($event)"
                  (onTokenized)="handleTokenized($event)"
                ></app-terminal-billing-form>
                <!--(onValidationChange)="handleTokenizeFormValidationChanged($event)"-->
              </div>
            </div>
            
            <div>
              <div style="margin-bottom: 20px; padding: 20px; border: 1px solid #eeeeee;" [hidden]="!showPane(PaneEnum.Shipping)">
                <div style="display:flex; flex-direction: row; justify-content: space-between; gap:10px; white-space: nowrap;">
                    <div style="width: 100%; font-size:1.2e; font-weight:400; margin-right: 20px;" >
                      04 Shipping            
                    </div>
                    <app-radio-group style="margin-bottom: 0px;" [options]="shippingOptions" [(ngModel)]="selectedShippingMode"></app-radio-group>
                </div>

                <div style="margin-top: 15px;" [hidden]="!showPane(PaneEnum.Shipping) || selectedShippingMode == 'none'">
                  <app-terminal-shipping-form [shippingAddress]="shippingAddress"></app-terminal-shipping-form>
                </div>
              </div>
            </div>


            <div [hidden]="orderDetails.transactionType == undefined || orderId != undefined">
              <div [hidden]="!showPane(PaneEnum.RecurringPayment)" style=" margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #eeeeee;">
              </div>
              <div style="text-align: center">
                <input type="button"\ value="Submit" class="primary" [disabled]="!formIsComplete || formIsBeingSubmitted" (click)="btnCompleteTransaction_click()" (keydown.enter)="btnCompleteTransaction_click()"/>
              </div>

            </div>
          </div>
        </div>

        <div class="terminalLayout-sidebar" [hidden]="this.orderDetails.transactionType == undefined || this.selectedMode == undefined">

          <app-terminal-summary [readyToSubmit]="formIsComplete" [orderDetails]="orderDetails" [selectedCustomer]="selectedCustomer" [selectedPaymentMethod]="selectedPaymentMethod" (onSubmit)="btnCompleteTransaction_click()"></app-terminal-summary>

        </div>

      </div>
    </div>
  </div>

</app-access-manager>
